<template>
  <div class="order_detail" v-if="order">
    <van-nav-bar
      title="订单详情"
      left-text=""
      right-text=""
      left-arrow
      @click-left="back"
    />

    <div class="status-card">
      <div v-if="order.status===1" class="status-h">待付款</div>
      <div v-if="order.status===2" class="status-h">已支付</div>
      <div v-if="order.status===3" class="status-h">已退款</div>
      <div v-if="order.status===5" class="status-h">已取消</div>
    </div>

    <div class="class-info-card" v-if="order.order_type=='clazz'">
      <div class="class-info-card-h">
        <div class="product-name">{{ order.clazz.clazz_name }}</div>
      </div>
      <div class="class-info-card-d">参与时间：<span>{{ order.clazz.start_time_format2 }} ~ {{ order.clazz.end_time_format2 }}</span></div>
      <div class="class-info-card-d">参与天数：<span>{{ order.clazz.day_num }}天</span></div>
      <div class="class-info-card-d">跑步天数：<span>{{ order.clazz.run_days }}天</span></div>
      <div class="class-info-card-d">每天距离：<span>{{ order.clazz.day_distance }}公里</span></div>
      <div class="class-info-card-price">
        <div class="app-dis-vcenter-row">
        金额：
        <div class="app-money">
          <span class="app-money-symbol">¥</span>
          <span class="fontWB">{{ order.clazz.contract_fee }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="class-info-card" v-if="order.order_type=='race'">
      <div class="class-info-card-h">
        <div class="product-name">{{ order.race.name }}</div>
      </div>
      <div class="class-info-card-d">参与时间：<span>{{ order.race.start_time }} ~ {{ order.race.end_time }}</span></div>
      <div class="class-info-card-d">赛事距离：<span>{{ order.race.distance }}公里</span></div>
      <div class="class-info-card-price">
        <div class="app-dis-vcenter-row">
        金额：
        <div class="app-money">
          <span class="app-money-symbol">¥</span>
          <span class="fontWB">{{ order.race.price }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="order.need_gift" class="class-info-card">
      <div class="class-info-card-h">
        <div class="product-name">礼包搭配</div>
      </div>
      <div v-if="order.gift.title" class="class-info-card-d">礼包标题：<span>{{order.gift.title}}</span></div>
      <div class="class-info-card-d">礼包内容：<span>{{order.gift.content}}</span></div>
      <div class="class-info-card-price">
        <div class="app-dis-vcenter-row">
        礼包价格：
        <div class="app-money">
          <span class="app-money-symbol">¥</span>
          <span class="fontWB">{{ order.gift.price }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="order-card">
      <div v-if="order.address" class="order-address-card-o">
        <div class="address-name">收货地址：</div>
        <div style="width: 350px; padding: 6px 0 6px;">
          <div class="address-tel">
            <div>{{ order.address.name }}</div>
            <div style="margin-left: 15px;">{{ order.address.tel }}</div>
          </div>
          <div class="address-area" style="max-width: 298px; margin-top: 5px;">
            {{ order.address.province }}{{ order.address.city }}{{ order.address.county }}{{ order.address.detail }}
          </div>
        </div>
      </div>

      <div class="order-card-o">
        <div>订单编号：</div><div>{{ order.sn }}</div>
      </div>
      <div class="order-card-o">
        <div>下单时间：</div><div>{{ order.add_time_format }}</div>
      </div>
      <div class="line" style="margin-bottom: 20px;"></div>
      <div v-if="order.status===2||order.status===3||order.status===4" class="order-card-o"><div>支付方式：</div>
        <div v-if="order.payment === 'free'">免费</div>
        <div v-else-if="order.payment === 'wxpay'">微信</div>
      </div>
      <div v-if="order.status===2||order.status===3||order.status===4" class="order-card-o"><div>付款时间：</div><div>{{ order.paytime_format }}</div></div>
      <div class="order-card-o">
        <div>合计：</div>
        <div>
          <div class="app-money">
            <span class="app-money-symbol">¥</span><span class="fontWB"> {{ order.total_price }}</span>
          </div>
        </div>
      </div>
      <div class="order-card-o">
        <div>优惠：</div>
        <div>
          <div class="app-money">
            <span class="app-money-symbol">¥</span>
            <span class="fontWB"> {{ order.prom_price }}</span>
          </div>
        </div>
      </div>
      <div class="order-card-o">
        <div class="app-dis-vcenter-row app-jus-end">
          <div style="margin-right: 0.2rem;">应付金额</div>
          <div class="app-color-error">
            <div class="app-money">
              <span class="app-money-symbol">¥</span><span class="fontWB"> {{ order.total_amount }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 20px"></div>
    </div>

    <div class="action-bar" v-if="order.status===1">
      <div class="order-pay-action">
        <div type="button" class="app-plain-btn order-pay-action-btn" style="margin-right: 10px;" @click="onCancel">
          <span>取消订单</span>
        </div>
        <div type="button" class="app-primary-btn order-pay-action-btn" @click="onPay">
          <span>立即付款</span>
        </div>
      </div>
    </div>
    <div class="action-bar" v-else-if="order.status===2 && order.need_gift">
      <div class="order-pay-action">
        <div type="button" class="app-primary-btn order-pay-action-btn" style="width: 120px" @click="onGift">
          <span>填写礼包信息</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, Toast, Dialog, NavBar } from 'vant'
import BottomPayBtn from '@/components/BottomPayBtn'
import { orderSimpleInfo, orderCancel, orderPay } from '@/api/order'
import { isWeixin } from '@/utils/index'
// import { isWeixin, wrapToBr } from '@/utils/index'
import { callPay } from '@/utils/wx'

export default {
  name: 'OrderConfirm',
  components: {
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    BottomPayBtn
  },
  data () {
    return {
      order: null
    }
  },
  created () {
    let orderNo = this.$route.params.order_no || ''
    this.getOrderInfo(orderNo)
  },
  methods: {
    async getOrderInfo (orderNo) {
      let response = await orderSimpleInfo(orderNo)
      this.order = response.data
      // if (this.order.gift) {
      //   this.order.gift.content = wrapToBr(this.order.gift.content)
      // }
    },
    async onCancel () {
      Dialog.confirm({
        title: '取消订单',
        message: '确定取消该订单吗？'
      }).then(async () => {
        Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
        await orderCancel(this.order.uuid)
        this.getOrderInfo(this.order.sn)
        Toast.clear()
      }).catch(() => {
      })
    },
    async onPay () {
      Toast.loading({ duration: 0, forbidClick: true, loadingType: 'spinner' })
      const response = await orderPay(this.order.uuid)
      Toast.clear()

      if (isWeixin()) {
        callPay(response.data)
      } else {
        Toast('请使用微信浏览器')
      }
    },
    onGift () {
      if (!this.order.gift.gift_link) return
      if (this.order.gift.gift_link.indexOf('http') !== 0) return
      location.href = this.order.gift.gift_link
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.order_detail {
  background-color: #f8f8f8;
  .line {
    height: 1px;
    background-color: #ebebeb;
    padding: 0;
  }
  .status-card {
    background-color: #f5222d;
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 60px;
    box-sizing: border-box;
    .status-h {
      font-size: 34px;
      font-weight: bold;
      margin-bottom: 16px;
      color: #fff;
    }
  }

  .class-info-card {
    // border-radius: 0.2rem;
    background-color: #ffffff;
    position: relative;
    padding: 40px 30px 0;
  }
  .class-info-card-h {
    font-size: 32px;
    line-height: 1;
    color: #222222;
    margin-bottom: 15px;
    .product-name {
      align-items: flex-start;
      word-wrap: break-word;
      word-break: break-all;
      line-height: 1.4;
      letter-spacing: 0;
    }
  }
  .class-info-card-d {
    color: #949494;
    font-size: 26px;
    line-height: 1.6;
  }
  .class-info-card-price {
    color: #949494;
    font-size: 26px;
    line-height: 1.6;
  }
  .app-dis-vcenter-row {
    display: flex;
    align-items: center;
  }
  .order-card {
    flex: 1;
    // border-radius: 0.2rem;
    background-color: #ffffff;
    padding: 47px 30px;
    padding-bottom: 10px;
    .order-card-o {
      display: flex;
      font-size: 28px;
      color: #222222;
      line-height: 1;
      margin-bottom: 36px;
      & > div:last-child {
        word-break: break-all;
        flex: 1;
        text-align: right;
      }
    }
  }
  .app-jus-end {
    justify-content: flex-end;
  }
  .app-color-error {
    color: #F54966;
  }
  .action-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #ffffff;
  }
  .order-pay-action {
    box-shadow: 0px 1px 0px 0px #ebebeb;
    border-top: 1px solid #ebebeb;
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    padding-top: 16px;
    padding-bottom: 16px;
    .order-pay-action-btn {
      width: 200px;
      height: 68px;
      font-size: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .order-address-card-o {
    padding: 0 0 15px;
    font-size: 26px;
    color: #949494;
    .address-name {
      font-size: 28px;
      color: #222222;
    }
    .address-tel {
      display: flex;
    }
  }
}
</style>
